import React, { useMemo } from 'react'

import { Link, Table } from '@domain-group/suit-theme'
import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useAgency'

const buildColumns = () => [
  {
    title: 'Title',
    dataKey: 'title',
    cellProps: {
      position: 'sticky',
      left: 0,
      width: 220,
    },
    render: (title: string, item: object) => {
      const { editAgencyUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {title}
        </Link>
      )
    },
  },
  {
    title: 'Agents',
    dataKey: 'agents_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (agents_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {agents_count}
        </Link>
      )
    },
  },
  {
    title: 'Admins',
    dataKey: 'office_administrators_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (office_administrators_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {office_administrators_count}
        </Link>
      )
    },
  },
  {
    title: 'Brand Groups',
    dataKey: 'brand_groups_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (brand_groups_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {brand_groups_count}
        </Link>
      )
    },
  },
  {
    title: 'Teams',
    dataKey: 'teams_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (teams_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {teams_count}
        </Link>
      )
    },
  },
  {
    title: 'Campaigns',
    dataKey: 'campaigns_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (campaigns_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {campaigns_count}
        </Link>
      )
    },
  },
  {
    title: 'Templates',
    dataKey: 'template_pages_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (template_pages_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {template_pages_count}
        </Link>
      )
    },
  },
  {
    title: 'Providers',
    dataKey: 'providers_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (providers_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {providers_count}
        </Link>
      )
    },
  },
  {
    title: 'Packages',
    dataKey: 'provider_packages_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (provider_packages_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {provider_packages_count}
        </Link>
      )
    },
  },
  {
    title: 'Publications',
    dataKey: 'publications_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (publications_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {publications_count}
        </Link>
      )
    },
  },
  {
    title: 'Image Libraries',
    dataKey: 'image_libraries_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (image_libraries_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {image_libraries_count}
        </Link>
      )
    },
  },
  {
    title: 'API Keys',
    dataKey: 'api_keys_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (api_keys_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {api_keys_count}
        </Link>
      )
    },
  },
  {
    title: 'Portals',
    dataKey: 'portals_count',
    cellProps: {
      textAlign: 'center',
    },
    render: (portals_count: number, item: object) => {
      const { editAgencyRelationsUrl } = generateUrls(item)

      return (
        <Link
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          textProps={{
            color: 'bodyFontColor',
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {portals_count}
        </Link>
      )
    },
  },
]

interface AgenciesRelationsTableProps {
  brandId: number,
  dataPayload: object[],
}

const AgenciesRelationsTable = (props: AgenciesRelationsTableProps) => {
  const { brandId, dataPayload } = props

  const memoColumns = useMemo(() => buildColumns(), [brandId, dataPayload.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={dataPayload}
      stickyHeader
    />
  )
}

export default React.memo(AgenciesRelationsTable)
